<div class="transaction-info-container">
    <app-header class="width-100"></app-header>
    <div class="rs-wrapper-v4">
        <mat-card>
            <h5>{{'order_status' | translate}}</h5>
            <form (submit)="getToken()" class="container-form" [formGroup]="transaction_state_form" fxLayout="column"
                fxLayoutAlign="start stretch">
                <mat-form-field appearance="outline">
                    <mat-label>{{'first_label' | translate}}</mat-label>
                    <input #field matInput type="text" formControlName="mid">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>{{'second_label' | translate}}</mat-label>
                    <input #field matInput type="text" formControlName="email">
                </mat-form-field>
                <app-submit [loading]="transactionStatePublic.is_saving">{{'consult_button' | translate}}</app-submit>
            </form>
        </mat-card>
        <mat-card *ngIf="showStateTransaction">
            <app-row-transaction-list [transaction]="transaction" [publicTransaction]="true"
                [opacity]="false"></app-row-transaction-list>
        </mat-card>
        <app-helper *ngIf="showStateTransaction" class="text-help" [severity]="severityEnum.INFO">{{'alert_text' | translate}}<a class="rs-link" [routerLink]="'my/login'">{{'alert_link' | translate}}</a>.</app-helper>
    </div>
    <app-footer class="width-100"></app-footer>
</div>
